var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1647 21.9573C10.943 21.9573 10.7214 21.8756 10.5464 21.7006L3.46469 14.619C3.12635 14.2806 3.12635 13.7206 3.46469 13.3823L10.5464 6.30062C10.8847 5.96229 11.4447 5.96229 11.783 6.30062C12.1214 6.63896 12.1214 7.19896 11.783 7.53729L5.31969 14.0006L11.783 20.464C12.1214 20.8023 12.1214 21.3623 11.783 21.7006C11.6197 21.8756 11.3864 21.9573 11.1647 21.9573Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9162 14.875H4.28125C3.80292 14.875 3.40625 14.4783 3.40625 14C3.40625 13.5217 3.80292 13.125 4.28125 13.125H23.9162C24.3946 13.125 24.7912 13.5217 24.7912 14C24.7912 14.4783 24.3946 14.875 23.9162 14.875Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadLeft);
export default __webpack_public_path__ + "static/media/lead-left.a4e9c43d6d84a51c829fde8c483e7db5.svg";
export { ForwardRef as ReactComponent };